import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Dropdown} from 'react-bootstrap';
import {getList} from '../../../../util/api';

const wdrShows = [
  {title: 'Lokalzeit Aachen', file: 'lz_aachen.json'},
  {title: 'Lokalzeit Bonn', file: 'lz_bonn.json'},
  {title: 'Lokalzeit Köln', file: 'lz_koeln.json'},
  {title: 'Lokalzeit Düsseldorf', file: 'lz_duesseldorf.json'},
  {title: 'Lokalzeit Duisburg', file: 'lz_duisburg.json'},
  {title: 'Lokalzeit Essen', file: 'lz_essen.json'},
  {title: 'Lokalzeit Dortmund', file: 'lz_dortmund.json'},
  {title: 'Lokalzeit Münster', file: 'lz_muenster.json'},
  {title: 'Lokalzeit Bielefeld', file: 'lz_bielefeld.json'},
  {title: 'Lokalzeit Siegen', file: 'lz_siegen.json'},
  {title: 'Lokalzeit Wuppertal', file: 'lz_wuppertal.json'},
  {title: 'Lokalzeit am Samstag', file: 'lz_samstag.json'}
];

const brShows = [
  {title: 'Rundschau', file: 'br_rundschau.json'},
  {title: 'Abendschau', file: 'br_abendschau.json'},
  {title: 'Frankenschau', file: 'br_frankenschau.json'}
];

const rbbShows = [{title: 'HBBTV', file: 'rbb_hbbtv.json'}];

const ardItems = [
  {title: 'Kurzwetter TS', file: ''},
  {title: 'Kurzwetter fm', file: ''},
  {title: 'BRD Temperaturen', file: 'ard_temperaturen.json'},
  {title: 'Aussichten', file: ''}
];
const hrItems = [
  {title: 'Kurzwetter TS', file: ''},
  {title: 'Kurzwetter fm', file: ''},
  {title: 'Hessen Temperaturen', file: ''},
  {title: 'Aussichten', file: ''}
];

export default class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shows: [],
      error: false
    };
  }

  async componentDidMount() {
    const list = await getList();
    if (!list.error) this.setState({shows: list});
    else this.setState({error: list.error});
  }

  createDropdown(props, broadcast) {
    return (
      <Dropdown.Menu>
        {broadcast.map((show, i) =>
          props.handleClick ? (
            <Dropdown.Item key={i}>
              <div
                onClick={() => {
                  props.handleClick(broadcast[i].file);
                }}>
                s
              </div>
            </Dropdown.Item>
          ) : (
            <Dropdown.Item
              key={broadcast[i].title}
              as={Link}
              to={'/' + broadcast[i].file}>
              {broadcast[i].title}
            </Dropdown.Item>
          )
        )}
      </Dropdown.Menu>
    );
  }

  render() {
    return (
      <div className={'nav'}>
        <Dropdown>
          <Dropdown.Toggle variant='2' id='dropdown-wdr'>
            WDR
          </Dropdown.Toggle>
          {this.createDropdown(this.props, wdrShows)}
        </Dropdown>
        <Dropdown>
          <Dropdown.Toggle variant='2' id='dropdown-br'>
            BR
          </Dropdown.Toggle>

          {this.createDropdown(this.props, brShows)}
        </Dropdown>

        <Dropdown>
          <Dropdown.Toggle disabled={false} variant='2' id='dropdown-rbb'>
            RBB
          </Dropdown.Toggle>
          {this.createDropdown(this.props, rbbShows)}
        </Dropdown>

        {['development'].includes(process.env.REACT_APP_ENV) && (
          <>
            <Dropdown>
              <Dropdown.Toggle variant='2' id='dropdown-ard'>
                ARD
              </Dropdown.Toggle>
              {this.createDropdown(this.props, ardItems)}
            </Dropdown>

            <Dropdown>
              <Dropdown.Toggle variant='2' id='dropdown-hr'>
                HR
              </Dropdown.Toggle>
              {this.createDropdown(this.props, hrItems)}
            </Dropdown>
          </>
        )}
      </div>
    );
  }
}
